import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PopupInfo from "@/components/popup/PopupInfo.vue";
import { store, ActionTypes, MutationTypes } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupInfoLeaveGroup',
  setup(__props) {

const clickAction = () => {
  const chatId = store.getters.GET_SELECTED_CHAT_ID;
  // @ts-expect-error
  store.dispatch(ActionTypes.LEAVE_GROUP_CHAT, { chatId });
  store.commit(MutationTypes.HIDE_POPUP);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupInfo, {
    title: "popup.PopupInfoLeaveGroup.title",
    label: "popup.PopupInfoLeaveGroup.label",
    "btn-text": "popup.PopupInfoLeaveGroup.btnText",
    action: clickAction
  }))
}
}

})